import React from 'react';

const StartMenu = ({ isOpen, onOpenWindow }) => {
  if (!isOpen) return null;

  const menuStyle = {
    position: 'fixed',
    top: '56px', // 8px wrapper-padding + 38px pill + 10px gap
    left: '16px', // Match TopBar margin
    width: '200px',
    background: 'rgba(29, 41, 53, 0.4)',
    backdropFilter: 'blur(60px) saturate(200%)',
    WebkitBackdropFilter: 'blur(60px) saturate(200%)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '0 0 5px 5px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 2px rgba(255, 255, 255, 0.15)',
    zIndex: 999999, // Above everything
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 0'
  };

  const itemStyle = {
    padding: '8px 15px',
    color: 'white',
    fontSize: '13px',
    cursor: 'pointer',
    borderBottom: '1px solid rgba(255,255,255,0.05)'
  };

  const hoverStyle = (e) => {
    e.target.style.background = '#00e5ff';
    e.target.style.color = 'black';
  };

  const leaveStyle = (e) => {
    e.target.style.background = 'transparent';
    e.target.style.color = 'white';
  };

  return (
    <div style={menuStyle}>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => onOpenWindow('terminal')}
      >
        📟 Terminal
      </div>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => onOpenWindow('projects')}
      >
        🚀 Projects
      </div>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => onOpenWindow('about')}
      >
        👨‍💻 About Me
      </div>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => onOpenWindow('cyberchef')}
      >
        🔧 Diptanshu's SwissArmy
      </div>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => onOpenWindow('taskmanager')}
      >
        📊 Task Manager
      </div>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => onOpenWindow('contact')}
      >
        📧 Contact Me
      </div>
      <div 
        style={itemStyle} 
        onMouseEnter={hoverStyle} 
        onMouseLeave={leaveStyle}
        onClick={() => alert("Shutting down... just kidding.")}
      >
        🛑 Log Out
      </div>
    </div>
  );
};

export default StartMenu;
